var React = require('react');

function ArrowLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Tracé 690","d":"m3.315 11.379 5.667-5.667a1.017 1.017 0 0 1 1.439 1.439L6.474 11.1H20.3a1.018 1.018 0 1 1 0 2.035H6.474l3.947 3.947a1.017 1.017 0 0 1-1.439 1.439l-5.667-5.669-.017-.017a1 1 0 0 1-.281-.532v-.005a.835.835 0 0 1-.012-.1H3V12.079a.835.835 0 0 1 .012-.1v-.005A1 1 0 0 1 3.3 11.4l.017-.017z","transform":"rotate(180 10.658 9.408)","style":{"fillRule":"evenodd"}}));
}

ArrowLink.defaultProps = {"width":"18.316","height":"13.402","viewBox":"0 0 18.316 13.402"};

module.exports = ArrowLink;

ArrowLink.default = ArrowLink;
